import tim from '@/shared/plugins/im'
import TIM from 'tim-js-sdk'
import Api from '@/api'
const imModules = {
  namespaced: true,
  state: {
    sdkReady: false,
    currentConversation: {},
    currentMessageList: [],
    nextReqMessageID: '',
    isCompleted: false, // 当前会话消息列表是否已经拉完了所有消息
    conversationList: [],
    c2cConversationList: [],
    //群聊
    groupList: [],
    currentMemberList: [],
    upFilePercent: 0,
  },
  getters: {
    hasGroupList: state => state.groupList.length > 0,
    toAccount: state => {
      if (!state.currentConversation || !state.currentConversation.conversationID) {
        return ''
      }
      switch (state.currentConversation.type) {
        case 'C2C':
          return state.currentConversation.conversationID.replace('C2C', '')
        case 'GROUP':
          return state.currentConversation.conversationID.replace('GROUP', '')
        default:
          return state.currentConversation.conversationID
      }
    },
    currentConversationType: state => {
      if (!state.currentConversation || !state.currentConversation.type) {
        return ''
      }
      return state.currentConversation.type
    },
    totalUnreadCount: state => {
      return state.conversationList.reduce((count, conversation) => {
        // 当前会话不计算总未读
        if (conversation.conversationID === state.currentConversation.conversationID) {
          return count
        }
        if (
          conversation.type === 'GROUP' &&
          conversation.groupProfile.selfInfo.messageRemindType === 'AcceptNotNotify'
        ) {
          return count
        }
        return count + conversation.unreadCount
      }, 0)
    },
    c2cUnreadCount: state => {
      return state.c2cConversationList.reduce((count, conversation) => {
        // 当前会话不计算总未读
        if (conversation.conversationID === state.currentConversation.conversationID) {
          return count
        }
        return count + conversation.unreadCount
      }, 0)
    },
    // 用于当前会话的图片预览
    imgUrlList: state => {
      return state.currentMessageList
        .filter(message => message.type === TIM.TYPES.MSG_IMAGE)
        .map(message => message.payload.imageInfoArray[0].url)
    }
  },
  mutations: {
    updatePercent(state, payload) {
      state.upFilePercent = Math.floor(payload * 100);
    },
    updateImState(state, payload) {
      state.sdkReady = payload;
    },
    /**
     * 更新当前会话
     * 调用时机: 切换会话时
     * @param {Object} state
     * @param {Conversation} conversation
     */
    updateCurrentConversation(state, conversation) {
      state.currentConversation = conversation
      state.currentMessageList = []
      state.nextReqMessageID = ''
      state.isCompleted = false
    },
    /**
     * 更新会话列表
     * 调用时机：触发会话列表更新事件时。CONVERSATION_LIST_UPDATED
     * @param {Object} state
     * @param {Conversation[]} conversationList
     */
    updateConversationList(state, conversationList) {
      if (!state.sdkReady) {
        return;
      }
      state.conversationList = conversationList.filter(item => item.type !== TIM.TYPES.CONV_SYSTEM);
      state.c2cConversationList = conversationList.filter(item => item.type === TIM.TYPES.CONV_C2C);
    },
    /**
     * 重置当前会话
     * 调用时机：需要重置当前会话时，例如：当前会话是一个群组，正好被踢出群时（被踢群事件触发），重置当前会话
     * @param {Object} state
     */
    resetCurrentConversation(state) {
      state.currentConversation = {}
    },
    /**
     * 将消息插入当前会话列表
     * 调用时机：收/发消息事件触发时
     * @param {Object} state
     * @param {Message[]|Message} data
     * @returns
     */
    pushCurrentMessageList(state, data) {
      // 还没当前会话，则跳过
      if (!state.currentConversation.conversationID) {
        return
      }
      console.log(Array.isArray(data))
      if (Array.isArray(data)) {
        // 筛选出当前会话的消息,并阻止系统群通知
        const result = data.filter(item => item.conversationID === state.currentConversation.conversationID && item.type !== TIM.TYPES.MSG_GRP_TIP)
        result.forEach(item => {
          if (item.type === 'TIMCustomElem') {
            let type = JSON.parse(item.payload.data).type;
            if (type === 'notice') {
              item.type = TIM.TYPES.MSG_GRP_TIP;
            }
          }
        })
        state.currentMessageList = [...state.currentMessageList, ...result];
      } else if (data.conversationID === state.currentConversation.conversationID) {
        if (data.type === 'TIMCustomElem') {
          let type = JSON.parse(data.payload.data).type;
          if (type === 'notice') {
            data.type = TIM.TYPES.MSG_GRP_TIP;
          }
        }
        state.currentMessageList = [...state.currentMessageList, data]
      }
    },
    reset(state) {
      Object.assign(state, {
        currentConversation: {},
        currentMessageList: [],
        nextReqMessageID: '',
        isCompleted: false, // 当前会话消息列表是否已经拉完了所有消息
        conversationList: []
      })
    },
    updateGroupList(state, groupList) {
      state.groupList = groupList
    },
    updateCurrentMemberList(state, memberList) {
      state.currentMemberList = [...state.currentMemberList, ...memberList]
    },
    deleteGroupMemeber(state, userID) {
      state.currentMemberList = state.currentMemberList.filter((member) => member.userID !== userID)
    },
    resetCurrentMemberList(state) {
      state.currentMemberList = []
    },
    resetGroup(state) {
      Object.assign(state, {
        groupList: [],
        currentMemberList: []
      })
    },
  },
  actions: {
    /**
     * 获取消息列表
     * 调用时机：打开某一会话时或下拉获取历史消息时
     * @param {Object} context
     * @param {String} conversationID
     */
    getMessageList(context, conversationID) {
      if (context.state.isCompleted) {
        context.dispatch("pushMessage", '已经没有更多的历史消息了哦', { root: true });
        return
      }
      const { nextReqMessageID, currentMessageList } = context.state;
      let conv = context.state.currentConversation;
      let sessionType = conv.type;
      let targetId = sessionType === 'GROUP' ? conv.groupProfile.groupID : conv.userProfile.userID;
      Api.im.getMessageList({ sessionType, targetId, nextReqMessageID, count: 15, }).then(res => {
        // 更新messageID，续拉时要用到
        context.state.nextReqMessageID = res.nextReqMessageID
        context.state.isCompleted = res.isCompleted
        let msg = [];
        res.messageList.forEach(item => {
          item.ID = item.id;
          item.nick = item.nickname;
          item.status = 'success';
          item.type = item.body[0].MsgType;
          item.payload = item.body[0].MsgContent;
          if (item.type === 'TIMCustomElem') {
            item.payload.data = item.payload.Data;
            try {
              let type = JSON.parse(item.payload.data).type;
              if (type === 'notice') {
                item.type = TIM.TYPES.MSG_GRP_TIP;
              }
            }catch (e) {
console.log(item)
            }
          }
          msg.push(item)
        })
        // 更新当前消息列表，从头部插入
        context.state.currentMessageList = [...msg, ...currentMessageList]

      })
      // tim.getMessageList({ conversationID, nextReqMessageID, count: 15 }).then(imReponse => {
      //   console.log('imReponse', imReponse)
      //   // 更新messageID，续拉时要用到
      //   context.state.nextReqMessageID = imReponse.data.nextReqMessageID
      //   context.state.isCompleted = imReponse.data.isCompleted
      //   // 更新当前消息列表，从头部插入
      //   context.state.currentMessageList = [...imReponse.data.messageList, ...currentMessageList]
      // })
    },
    /**
     * 切换会话
     * 调用时机：切换会话时
     * @param {Object} context
     * @param {String} conversationID
     */
    checkoutConversation(context, conversationID) {
      context.commit('resetCurrentMemberList')
      // 1.切换会话前，将切换前的会话进行已读上报
      if (context.state.currentConversation.conversationID) {
        const prevConversationID = context.state.currentConversation.conversationID
        tim.setMessageRead({ conversationID: prevConversationID })
      }
      // 2.待切换的会话也进行已读上报
      tim.setMessageRead({ conversationID })
      // 3. 获取会话信息
      return tim.getConversationProfile(conversationID).then(({ data }) => {
        // 3.1 更新当前会话
        context.commit('updateCurrentConversation', data.conversation)
        // 3.2 获取消息列表
        context.dispatch('getMessageList', conversationID)
        // 3.3 拉取第一页群成员列表
        // if (data.conversation.type === TIM.TYPES.CONV_GROUP) {
        //   return context.dispatch('getGroupMemberList', data.conversation.groupProfile.groupID)
        // }
        return Promise.resolve()
      })
    },
    async updateGroupList(context) {
      let { list } = await Api.im.groupList();
      context.commit('updateGroupList', list)
      //群组未读消息处理
      for (let i in list) {
        let item = list[i];
        if (item.is_disbanded == 0) {
          if(item.is_master) {
            let { data: { conversation } } = await tim.getConversationProfile('GROUP' + item.id);
            item.unreadCount = conversation.unreadCount
          }
        } else {
          item.unreadCount = 0
        }
      }
      // context.commit('updateGroupList', list)
    },
    getGroupMemberList(context, groupID) {
      return tim.getGroupMemberList({
        groupID: groupID,
        offset: context.state.currentMemberList.length,
        count: 30
      }).then((imResponse) => {
        context.commit('updateCurrentMemberList', imResponse.data.memberList)
        return imResponse
      })
    },
    async logout(context) {
      await tim.logout();
      context.commit('updateImState', false)
    }

  }
}

export default imModules
